import { Skeleton } from "antd";
import { FC } from "react";

interface TMSkeletonProps {}

const TMSkeleton: FC<TMSkeletonProps> = ({}) => {
  return (
    <div className="p-4 shadow border rounded">
      <div className="flex items-center gap-2">
        <div className="flex rounded-full">
          <Skeleton.Avatar active size={70} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </div>
      </div>
    </div>
  );
};

export default TMSkeleton;
